import React, { Component } from 'react';
import { Form, Formik, ErrorMessage } from 'formik';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomSelectGroup from '../../../../common/formElements/CustomSelectGroup';
import { dynamicSort } from '../../../../common/utils/api_utils';
import {
  getTemplateCollectionFieldOptions,
  getProjectConstantOptions,
  getSessionOptions,
  getTemplateCollectionNameFieldOptions,
} from './AgreementFieldsUtil';
import CustomRadio from '../../../../common/ui/CustomRadio';
import * as Yup from 'yup';

export default class AgreementTemplateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTemplateId: null,
    };
  }

  createValidationSchema = () => {
    return Yup.object().shape({
      templateId: Yup.string().required('Agreement Template is required'),
      nameFields: Yup.array().min(1, 'At least one name field is required'),
      emailFields: Yup.array().min(1, 'At least one email field is required'),
    });
  };

  createSchemaForFields = () => {
    const { agreementTemplateRule = {} } = this.props;
    return {
      templateId: agreementTemplateRule.templateId || '',
      nameFields: agreementTemplateRule.nameFields || [],
      emailFields: agreementTemplateRule.emailFields || [],
      emailCcFields: agreementTemplateRule.emailCcFields || [],
      emailBccFields: agreementTemplateRule.emailBccFields || [],
      sendToPropagate: agreementTemplateRule.sendToPropagate || false,
    };
  };

  getAgreementTemplateOptions = () => {
    const baseOption = { value: '', label: '-Select One-' };
    const templateOptions = this.props.agreementTemplates
      .filter((item) => !item.parentTemplateId)
      .sort(dynamicSort('name'))
      .map((item) => ({ value: item.uuid, label: item.name }));

    return [baseOption, ...templateOptions];
  };

  //TODO: DOCUSIGN below two methods are similar, need to refactor and combine then using conditions
  getAgreementFieldsOptions = (templateId) => {
    const { collections, agreementTemplates, projectDetail } = this.props;

    // Find selected template
    const selectedTemplate =
      collections && agreementTemplates && templateId
        ? agreementTemplates.find((e) => e.uuid === templateId)
        : null;

    // Find corresponding collection
    const templateCollectionName = selectedTemplate ? selectedTemplate.collectionId : null;
    const templateCollection =
      collections && templateCollectionName
        ? collections.find((e) => e.collectionName === templateCollectionName)
        : null;

    // Generate options
    const options = getTemplateCollectionFieldOptions(templateCollection, collections);
    const projectConstantOptions = getProjectConstantOptions(projectDetail);
    const sessionOptions = getSessionOptions(collections);

    return [
      { label: 'Fields', options },
      { label: 'Project Constant', options: projectConstantOptions },
      { label: 'Current LoggedIn User', options: sessionOptions },
    ];
  };

  getAgreementNameFieldsOptions = (templateId) => {
    const { collections, agreementTemplates, projectDetail } = this.props;

    // Find selected template
    const selectedTemplate =
      collections && agreementTemplates && templateId
        ? agreementTemplates.find((e) => e.uuid === templateId)
        : null;

    // Find corresponding collection
    const templateCollectionName = selectedTemplate ? selectedTemplate.collectionId : null;
    const templateCollection =
      collections && templateCollectionName
        ? collections.find((e) => e.collectionName === templateCollectionName)
        : null;

    // Generate options
    const options = getTemplateCollectionNameFieldOptions(templateCollection, collections);
    const projectConstantOptions = getProjectConstantOptions(projectDetail);
    const sessionOptions = getSessionOptions(collections);

    return [
      { label: 'Fields', options },
      { label: 'Project Constant', options: projectConstantOptions },
      { label: 'Current LoggedIn User', options: sessionOptions },
    ];
  };

  handleSubmit = (values) => {
    this.props.handleSubmit(values);
  };

  handleTemplateChange = (setFieldValue, value) => {
    // Reset dependent fields when template changes
    setFieldValue('templateId', value);
    setFieldValue('nameFields', []);
    setFieldValue('emailFields', []);
    setFieldValue('emailCcFields', []);
    setFieldValue('emailBccFields', []);
  };

  render() {
    const { children } = this.props;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createSchemaForFields()}
        validationSchema={this.createValidationSchema()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label>{'Agreement Template'}*</label>
                  <CustomSelect
                    name="templateId"
                    isMulti={false}
                    onChange={(name, value) => this.handleTemplateChange(setFieldValue, value)}
                    onBlur={setFieldTouched}
                    options={this.getAgreementTemplateOptions()}
                    value={values.templateId}
                  />
                  <ErrorMessage name="templateId">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select a template you want to send via this event.</small>
                </div>

                <div className="form-group">
                  <label>{'Name Fields'}*</label>
                  <CustomSelectGroup
                    name="nameFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getAgreementNameFieldsOptions(values.templateId)}
                    value={values.nameFields}
                  />
                  <ErrorMessage name="nameFields">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the name field.</small>
                </div>

                <div className="form-group">
                  <label>{'Email Address Fields'}*</label>
                  <CustomSelectGroup
                    name="emailFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getAgreementFieldsOptions(values.templateId)}
                    value={values.emailFields}
                  />
                  <ErrorMessage name="emailFields">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the email address field.</small>
                </div>

                <div className="form-group">
                  <label>{'Email Address (CC) Fields'}*</label>
                  <CustomSelectGroup
                    name="emailCcFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getAgreementFieldsOptions(values.templateId)}
                    value={values.emailCcFields}
                  />
                  <small>Select the email address (CC) field.</small>
                </div>

                <div className="form-group">
                  <label>{'Email Address (BCC) Fields'}*</label>
                  <CustomSelectGroup
                    name="emailBccFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getAgreementFieldsOptions(values.templateId)}
                    value={values.emailBccFields}
                  />
                  <small>Select the email address (BCC) field.</small>
                </div>

                <div className="form-group form-check">
                  <CustomRadio label="Send Propagated Collection" isRadio={false}>
                    <input
                      name="sendToPropagate"
                      type="checkbox"
                      className="form-check-input"
                      checked={values.sendToPropagate}
                      onChange={(e) => setFieldValue('sendToPropagate', e.target.checked)}
                    />
                  </CustomRadio>
                </div>
              </div>
            </div>
            {children}
          </Form>
        )}
      </Formik>
    );
  }
}
